export enum ShapeKeys {
  DRAG_ID,
  DRAG_STATE,
  SHAPE_TYPE,
  SHAPE_BACKGROUND_COLOR,
  BLOCK,
  ACTIVE_EXTERNAL_SELECTION,
  GUID,
}
